export default __webpack_public_path__ + "static/carousel_light-fe99bcd560cbb9c7137c2207fb05d137.gif";